<fcom-notification *ngIf="origin && destination && availability?.length" [layout]="NotificationLayout.EDGE_TO_EDGE">
  <div>
    <p
      class="font-body-1"
      [innerHTML]="
        (availability?.length > 1 ? 'timetable.seasonalNotification.plural' : 'timetable.seasonalNotification.singular')
          | finLocalization
            : {
                origin: origin,
                destination: destination,
                start: availability[0].start | finDateFormat: 'MMMM yyyy',
                end: availability[0].end | finDateFormat: 'MMMM yyyy',
                start2: availability?.length > 1 ? (availability[1].start | finDateFormat: 'MMMM yyyy') : null,
                end2: availability?.length > 1 ? (availability[1].end | finDateFormat: 'MMMM yyyy') : null,
              }
      "
    ></p>
    <p class="font-body-1 ms-xsmall-t" [innerHTML]="'timetable.seasonalNotification.oneWorld' | finLocalization"></p>
  </div>
</fcom-notification>
